


































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import Pagination from '@/components/Pagination.vue';
import ApiKeyModule from '@/store/modules/ApiKey';
import NewLobbyModule from '@/store/modules/NewLobby';
import AuthModule from '@/store/modules/Auth';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';

@Component({
  components: {
    Table,
    Pagination,
    Breadcrumb,
  },
})
export default class SeamlessKey extends Mixins(ErrorHandleMixin, PaginationMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Agent',
        attr: {
          class: 'text-center',
        },
      },
      {
        text: 'Status',
      },
    ],
  ];

  ApiKeyInstance = getModule(ApiKeyModule, this.$store);

  NewLobbyInstance = getModule(NewLobbyModule, this.$store)

  AuthInstance = getModule(AuthModule, this.$store);

  searchText = '';

  editModel = {
    _id: '',
    isNewLobbyFeature: false,
  };

  data = [];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  username = '';

  id = '';

  BreadcrumbList: any = [];

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      userId: this.AuthInstance.user._id,
      source: this.AuthInstance.user.source,
    },
  ];

  created() {
    this.fetchFlag();
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.calPagination({ ...this.paginationParams });
    this.fetchFlag();
  }

  handleFetch(item) {
    this.username = item.username;
    this.id = item._id;
    this.fetchFlag();
  }

  async fetchFlag() {
    this.GeneralInstance.toggleLoading(true);
    const params = {
      username: this.username ? this.username : this.AuthInstance.user.username,
      _id: this.id ? this.id : '',
    };
    const res = await this.NewLobbyInstance.FetchFlag(params);
    if (res.code) {
      this.checkError(res);
    }
    this.WinLoseList = {
      data: this.NewLobbyInstance.listFlag.items,
      pageAmount: Math.ceil(res.items.length / 100),
    };
    const breadcrumb = this.NewLobbyInstance.listFlag.breadcrumbs;
    this.BreadcrumbList = [...this.BreadcrumbDefault, ...breadcrumb];
    await this.calPagination({
      instance: 'WinLoseList',
      dataKey: 'data',
    });
    this.data = this.dataList;
    this.GeneralInstance.toggleLoading(false);
  }

  handleSearch() {
    this.data = this.NewLobbyInstance.listFlag.items
      .filter((item) => item.username
        && item.username.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  handleEdit(item) {
    const {
      _id, isNewLobbyFeature,
    } = item;
    this.editModel._id = _id;
    this.editModel.isNewLobbyFeature = !isNewLobbyFeature;
    this.handleSave();
  }

  async handleSave() {
    const res = await this.NewLobbyInstance.EditFlag(this.editModel);
    this.checkError(res);
    await this.fetchFlag();
  }

  async handleBreadcrumb(user) {
    this.prepareFetch(user);
  }

  prepareFetch(user) {
    this.username = user.username;
    this.id = user._id;
    this.fetchFlag();
  }
}
